import { PageIllustrationSvg as e } from "./Illustration.styled.mjs";
import { renderIllNode as t } from "./renderIllNode.mjs";
import n from "react";
import { jsx as r } from "react/jsx-runtime";
import { ILL_PAGE_SCENES as i } from "@maat/assets";
//#region src/components/Illustration/PageIllustration.tsx
var a = 320, o = 260, s = ({ name: a, width: o = 320, playKey: s, motion: c = !0, className: l }) => {
	let u = i[a], [d, f] = n.useState(c);
	n.useEffect(() => {
		if (!c) {
			f(!1);
			return;
		}
		f(!0);
		let e = setTimeout(() => f(!1), u.dur);
		return () => clearTimeout(e);
	}, [
		s,
		u.dur,
		c
	]);
	let p = [
		d ? "pl" : void 0,
		c ? "mo" : void 0,
		l
	].filter(Boolean).join(" ");
	return /* @__PURE__ */ r(e, {
		viewBox: `0 0 ${u.width} ${u.height}`,
		width: o,
		height: o * (u.height / u.width),
		className: p || void 0,
		"aria-hidden": "true",
		focusable: "false",
		children: u.nodes().map(t)
	});
};
//#endregion
export { o as PAGE_ILLUSTRATION_MIN_WIDTH, a as PAGE_ILLUSTRATION_WIDTH, s as PageIllustration };
